import { Api } from "@mcleod/core";
import { LMEUserSettings } from "@mcleod/general";
import { AutogenLayoutCarrierQuickInfo } from "./autogen/AutogenLayoutCarrierQuickInfo";

export class CarrierQuickInfo extends AutogenLayoutCarrierQuickInfo {

    public pendingCancelled = (lock_changed: boolean, user_can_unlock: boolean) => { };



    /** This is an event handler for the onDisplay event of sourceCarriersForAssignment.  */
    sourceCarriersForAssignmentOnDisplay(event) {
        this.labelPendingCarrier.visible = this.mainDataSource.activeRow?.get("pending_carrier") == true;
        this.textboxId.text = this.mainDataSource.activeRow?.get("id");

        const userId = LMEUserSettings.getUserId();
        this.buttonCancel.visible = userId == this.mainDataSource.activeRow?.get("locked_user");

        this.isoCarrierLabel.visible = this.mainDataSource.activeRow?.get("show_iso_icon") === true;
        if(this.isoCarrierLabel.visible){
            Api.search("lme/powerbroker/carrier-scorecard",
                {
                    "vendor_id": "I",
                    "dot_number": this.mainDataSource.activeRow?.get("dot_number"),
                    "mc_number": this.mainDataSource.activeRow?.get("icc_number")
                }).then((response) => {
                this.isoCarrierLabel.link = response?.data?.[0]?.iso_portal_url;
            })
        }
    }

    async cancelPendingAssignment() {
        const response = await Api.post("lme/powerbroker/move-locking", { movement_id: this.mainDataSource.activeRow?.get("movement_id"), action: "cancel_pending" });
        this.pendingCancelled(response.data[0]?.lock_changed, response.data[0]?.user_can_unlock);
    }
}
